import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { ProgressBarComponent } from 'src/app/components/card/card-progress/card-progress.component';
import { CardComponent } from 'src/app/components/card/card.component';
import { CardModule } from 'src/app/components/card/card.module';
import { DirectivesModule } from 'src/app/directives/directives.modules';
import { CardEntity } from 'src/app/models/entities/card.entity';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { BoardService } from 'src/app/services/api/board.service';
import { MenuService } from 'src/app/services/heading-service';

@Component({
    selector: 'app-card-due-dates',
    imports: [CommonModule, CardModule, MatCardModule, ProgressBarComponent, PipesModule],
    templateUrl: './card-due-dates.component.html',
    styleUrl: './card-due-dates.component.scss'
})
export class CardDueDatesComponent {
  @Input() cards: any[] = [];
  @Input() fixedHeight: boolean = false;
  @Input() fullWidth: boolean = false;
  @Output() clicked: EventEmitter<CardEntity> = new EventEmitter<CardEntity>();
  private boardKey = '';
  constructor(private router: Router, private route: ActivatedRoute, private boardService: BoardService, private menuService: MenuService) {
    route.params.subscribe(params => {
      this.boardKey = params['boardId'];
    });
  }


  navigate(card: CardEntity): void {
    
    this.clicked.emit(card);
    this.boardService.selectedBoard$.next(null);

    const targetUrl = `/board/${card.boardKey}/${card.key}`;
    const currentUrl = this.router.url;

    if (currentUrl !== targetUrl &&  currentUrl.lastIndexOf(card.boardKey)  === -1 ) {

      this.router.navigate([targetUrl], { queryParams: { reload: 'true' } });
    } else {
      this.menuService.setCardSelected(card);
    }
  }

}
